export default "__VITE_ASSET__tbexvrFc__"